/* @flow */
import Organization from 'entities/Organization';
import API from 'lib/RemindAPI';

type Sort = 'first_name' | 'last_name' | 'join_date' | 'role';
type SortDirection = 'desc' | 'asc';

export type SchoolFetchOptions = {
  page: number,
  perPage: number,
  sortDirection?: SortDirection,
  sort?: Sort,
};

export function fetch(id: Backbone$Id, parameters: SchoolFetchOptions) {
  const options = {
    sort_type: parameters.sort,
    per_page: parameters.perPage,
    sort_direction: parameters.sortDirection,
    page: parameters.page,
    limit_to_joined_orgs: true,
  };

  return API.request(`/organizations/${id}/schools`, 'GET', options).then(response =>
    response.schools.map(o => Organization.fromJSON(o))
  );
}
